import { type FormEvent, useState } from "react";

import type { CanonicalError } from "../api/contracts";

export function Login({
  error,
  onLogin,
  pending,
}: {
  error: CanonicalError | null;
  onLogin: (token: string) => Promise<void>;
  pending: boolean;
}) {
  const [token, setToken] = useState("");

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const supplied = token;
    setToken("");
    await onLogin(supplied);
  }

  return (
    <main className="login-shell">
      <section className="login-card" aria-labelledby="login-title">
        <div className="brand-mark" aria-hidden="true">LB</div>
        <p className="eyebrow">LoveBomber Platform</p>
        <h1 id="login-title">Dev Chat</h1>
        <p className="login-copy">
          Enter the deployment UUID to open the full connector flow.
        </p>
        <form onSubmit={(event) => void submit(event)}>
          <label htmlFor="deployment-token">Deployment UUID</label>
          <input
            id="deployment-token"
            name="deployment-token"
            type="password"
            autoComplete="off"
            spellCheck={false}
            value={token}
            onChange={(event) => setToken(event.target.value)}
            disabled={pending}
            required
            aria-describedby={error ? "login-error" : undefined}
          />
          {error ? (
            <div id="login-error" className="form-error" role="alert">
              <span>{error.message}</span>
              <code>{error.code}</code>
            </div>
          ) : null}
          <button className="primary-button login-button" type="submit" disabled={pending || token.length === 0}>
            {pending ? "Signing in…" : "Open Dev Chat"}
          </button>
        </form>
      </section>
    </main>
  );
}
